import { supabase } from '../lib/supabase';
import { api } from './api';

// Re-export setAuthToken to keep it in one place
let currentAuthToken: string | null = null;
export const setAuthToken = (token: string | null) => {
  currentAuthToken = token;
};

export const getAuthToken = () => currentAuthToken;

let authInitialized = false;
let authInitPromise: Promise<void> | null = null;

export const initializeAuth = async () => {
  // If already initialized, return immediately
  if (authInitialized) {
    return;
  }

  // If initialization is in progress, return that promise
  if (authInitPromise) {
    return authInitPromise;
  }

  // Start initialization
  authInitPromise = new Promise<void>(async (resolve) => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        // Set the token in the API service
        setAuthToken(session.access_token);
      }
    } catch (error) {
      console.error('Failed to initialize auth:', error);
    } finally {
      authInitialized = true;
      authInitPromise = null;
      resolve();
    }
  });

  return authInitPromise;
};

// Listen for auth state changes
supabase.auth.onAuthStateChange((_event, session) => {
  if (session?.access_token) {
    setAuthToken(session.access_token);
  } else {
    setAuthToken(null);
  }
});

let authToken: string | null = null;

export const refreshAuthToken = async (): Promise<string | null> => {
  try {
    const response = await api.post('/api/auth/refresh');
    const newToken = response.data.access_token;
    setAuthToken(newToken);
    return newToken;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return null;
  }
}; 